import { useState, useCallback } from 'react';
import { toast } from 'react-toastify';

// Shared state machine for every page-wise "AI ..." button: opens AIResultPanel,
// runs the given API call, and surfaces loading/error/content/groups.
export default function useAIAction() {
  const [state, setState] = useState({ isOpen: false, loading: false, error: null, content: null, groups: null, title: '', docType: 'note' });

  // docType picks the export template in AIResultPanel: 'protocol' | 'report' | 'note' (default).
  const run = useCallback(async (title, apiCall, docType = 'note') => {
    setState({ isOpen: true, loading: true, error: null, content: null, groups: null, title, docType });
    try {
      const res = await apiCall();
      const data = res?.data?.data || {};
      setState({ isOpen: true, loading: false, error: null, content: data.content || null, groups: data.groups || null, title, docType });
    } catch (err) {
      const message = err?.response?.data?.message || err.message || 'AI request failed';
      setState({ isOpen: true, loading: false, error: message, content: null, groups: null, title, docType });
      if (err?.response?.status !== 400) toast.error(message);
    }
  }, []);

  const close = useCallback(() => setState((s) => ({ ...s, isOpen: false })), []);

  return { ...state, run, close };
}
